import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Preloader() {
    const [done, setDone] = useState(false);
    const [gone, setGone] = useState(() => sessionStorage.getItem("voc-visited") === "1");
    const fast = sessionStorage.getItem("voc-visited") === "1";
    const duration = fast ? 0.5 : 1.3;

    useEffect(() => {
        document.body.style.overflow = "hidden";
        const t = setTimeout(() => {
            setDone(true);
            sessionStorage.setItem("voc-visited", "1");
            document.body.style.overflow = "";
        }, duration * 1000 + 150);
        return () => clearTimeout(t);
    }, [duration]);

    if (gone && done) return null;

    return (
        <AnimatePresence>
            {!done && (
                <motion.div
                    data-testid="preloader"
                    className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-[#F2F0EA]"
                    exit={{ y: "-100%" }}
                    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                >
                    <motion.p
                        initial={{ opacity: 0, y: 14 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                        className="font-display text-[11px] font-semibold uppercase tracking-[0.5em] text-[#0A0A0A]"
                    >
                        Vantage Owners Club
                    </motion.p>
                    <div className="mt-8 h-px w-40 overflow-hidden bg-[#222]">
                        <motion.div
                            className="h-full bg-[#0A0A0A]"
                            initial={{ scaleX: 0 }}
                            animate={{ scaleX: 1 }}
                            style={{ originX: 0 }}
                            transition={{ duration, ease: "easeInOut" }}
                        />
                    </div>
                    <motion.p
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 0.4 }}
                        transition={{ delay: 0.4, duration: 0.6 }}
                        className="mt-4 text-[9px] uppercase tracking-[0.35em] text-[#8E8D8A]"
                    >
                        Est. 2026
                    </motion.p>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
